/**
 * Filter item definition interface.
 */
var GridLinkOperator;

(function (GridLinkOperator) {
  GridLinkOperator["And"] = "and";
  GridLinkOperator["Or"] = "or";
})(GridLinkOperator || (GridLinkOperator = {}));

export { GridLinkOperator };


//////////////////
// WEBPACK FOOTER
// ../@mui/x-data-grid/models/gridFilterItem.js
// module id = 352
// module chunks = 25